import { cn } from '~/utils/cn';

export function DividerHorizontal({ className }: { className?: string }) {
  return <div className={cn('h-px w-full bg-intense-03', className)} />;
}

export function DividerVertical({ className }: { className?: string }) {
  return <div className={cn('w-px h-full bg-intense-03', className)} />;
}
